import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { SlideTransition } from "../transition";
import { useConfig } from "../_util/config-context";
export var FormControl = React.forwardRef(function FormControl(_a, ref) {
    var _b;
    var status = _a.status, children = _a.children, message = _a.message, extra = _a.extra, alignLabelTop = _a.alignLabelTop, _c = _a.showStatusIcon, showStatusIcon = _c === void 0 ? true : _c, className = _a.className, props = __rest(_a, ["status", "children", "message", "extra", "alignLabelTop", "showStatusIcon", "className"]);
    var classPrefix = useConfig().classPrefix;
    var controlClassName = classNames(classPrefix + "-form__controls", (_b = {},
        _b[classPrefix + "-form__controls--text"] = alignLabelTop,
        _b["is-" + status] = status,
        _b), className);
    return (React.createElement("div", __assign({ ref: ref, className: controlClassName }, props),
        children,
        React.createElement(SlideTransition, { in: Boolean(status), from: [-10, 0] }, showStatusIcon ? (React.createElement("b", { className: classPrefix + "-icon " + classPrefix + "-icon-valid" })) : (React.createElement("b", null))),
        Boolean(message) && (React.createElement("div", { className: classPrefix + "-form__help-text" }, message)),
        Boolean(extra) && (React.createElement("div", { className: classNames(classPrefix + "-form__help-extra", classPrefix + "-form__help-text", classPrefix + "-text-label") }, extra))));
});
FormControl.displayName = "FormControl";
//# sourceMappingURL=FormControl.js.map